// extracted by mini-css-extract-plugin
module.exports = {"container":"QuickDetails_container__kkEzx","grid":"QuickDetails_grid__ieVNB","item":"QuickDetails_item__FlnNc","itemHeadline":"QuickDetails_itemHeadline__oyDtp"};